import React from 'react';
import { Loader2 } from 'lucide-react';

export const LoadingScreen = ({ label = 'Cargando…' }) => (
  <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--ns-bg)] text-[var(--ns-text)]">
    <Loader2 className="h-8 w-8 text-[var(--ns-gold)] animate-spin" />
    <p className="mt-3 text-sm text-[var(--ns-text-muted)]">{label}</p>
  </div>
);
